import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import {
	MORNINGSTAR_STYLE_BOX_CATEGORY_KEY,
	MORNINGSTAR_STYLE_BOX_COMPONENT_KEY,
} from '../MorningstarStyleBox.meta.js';

const rawCssPrefix = `
	width: 215px;
`;

export default InjectedStyledComponent(
	'section',
	MORNINGSTAR_STYLE_BOX_CATEGORY_KEY,
	MORNINGSTAR_STYLE_BOX_COMPONENT_KEY,
	['wrapper'],
	rawCssPrefix,
);
